import { produce } from 'immer';

import type { ID as REPORT_MODAL_ID, Data as ReportModalData } from '~/components/layout/modal/report';
import { useStore } from '../store';

export interface ModalData {
  id: typeof REPORT_MODAL_ID;
  data: ReportModalData;
}

export const setModal = (data: ModalData | null) => {
  useStore.setState(state =>
    produce(state, draft => {
      draft.modal = data;
    })
  );
};
